//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";

import * as action from "./actions"





export const handleAutologinOneGame = (userId, classId, metadata) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/session_sync`, {
            body: {
                "uri": window.location.href,
                "userId": userId,
                "classId": classId,
                metadata
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'autologin one game',
                error,
                module: 'ONE_GAME',
                operation: 'ADD_ORGANIZATION_GROUP'
            });
        }
    }
};
export const handleSyncBookCategories = (userId) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/user_category_sync`, {
            body: {
                "userId": userId
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing book categories',
                error,
                module: 'ONE_GAME',
                operation: 'SET_BOOK_CLASS'
            });
        }
    }
};

export const handleListGame = (userId, bookId, pageId, type, game_type, is_story, resource, is_user_Admin) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/list_games`, {
            body: {
                userId,
                bookId,
                pageId,
                type,
                game_type,
                is_story,
                resource,
                is_user_Admin
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing game',
                error,
                module: 'ONE_GAME',
                operation: 'LIST_GROUP'
            });
        }
    }
};

export const handleListGameByBook = (userId, bookId, type, game_type) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/list_games_book`, {
            body: {
                userId,
                bookId,
                type,
                game_type
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing game',
                error,
                module: 'ONE_GAME',
                operation: 'LIST_GROUP'
            });
        }
    }
};

export const handleStartGame = (userId, gameId, classId , game_config ) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/start_game_session`, {
            body: {
                userId,
                gameId,
                classId,
                game_config
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'starting game',
                error,
                module: 'ONE_GAME',
                operation: 'SET_GROUP'
            });
        }
    }
};


export const handleGameBySessionId = (userId, session_id) => async (dispatch) => {
    if(!userId || !session_id)  return;
    try {
        const oneGameSyncData = await apis.post('one_game', `/get_game_session_by_id`, {
            body: {
                userId,
                session_id
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting game by session id',
                error,
                module: 'ONE_GAME',
                operation: 'GET_GROUP_BOOK_STUDENT_INSTRUCTION'
            });
        }
    }
};

export const handleCheckGameJoined = (userId, session_id) => async (dispatch) => {
    if(!userId || !session_id)  return;
    try {
        const oneGameSyncData = await apis.post('one_game', `/check_game_joined`, {
            body: {
                userId,
                session_id
            }
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ONE_GAME',
                operation: 'AUTOLOGIN_ONE_GAME'
            })
        }
    }
};


export const handleGameDelete = (userId, id) => async (dispatch) => {
    try {
        const oneGameDeleteData = await apis.post('one_game', `/delete_game`, {
            body: {
                userId,
                id,
            }
        });
        return oneGameDeleteData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting game',
                error,
                module: 'ONE_GAME',
                operation: 'DELETE_GROUP'
            });
        }
    }
};
export const handleListClassGameActivity = (class_id) => async (dispatch) => {
    try {
        const class_game_activity = await apis.post('one_game', `/list_class_game`, {
            body: {
                class_id
            }
        });
        if (Array.isArray(class_game_activity)) {
            dispatch(action.setClassGameActivity(class_game_activity))
        }
        return class_game_activity;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class game activity',
                error,
                module: 'ONE_GAME',
                operation: 'LIST_CLASS_GROUP_ACTIVITY'
            });
        }
        return null;
    }
};

export const handleBookContent = (payload) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('booksRDS', `/getBookContent/get_book_content`, {
            body: payload
        });
        return oneGameSyncData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'ONE_GAME',
                operation: 'SYNC_BOOK_CATEGORIES'
            })
        }
    }
};

export const handleListClassGameActivityForStudentWithIds = (class_id, userId, ids = []) => async (dispatch) => {
    try {
        const class_game_activity = await apis.post('one_game', `/list_class_game_activity_for_student_with_ids`, {
            body: {
                class_id,
                activityIds: ids
            }
        });
        if (Array.isArray(class_game_activity)) {
            if(class_game_activity?.length > 0){
                class_game_activity.forEach(item => {
                    if(item?.game_id){
                        dispatch(action.listClassGameActivityForStudentWithIds(item));
                    }
                })
            }else{
                dispatch(action.listClassGameActivityForStudentWithIds({activityIds: ids, isDeleted: true}));
            }
        }
        return class_game_activity;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class game activity for student with ids',
                error,
                module: 'ONE_GAME',
                operation: 'LIST_CLASS_GAME_ACTIVITY_FOR_STUDENT_WITH_IDS'
            });
        }
        return null;
    }
};